/**
 * NavMenu.js
 * Navigational Component with trigger button or icon, powered by ListContainer
 *
 * @class   NavMenu
 * @author  Yevgeniy Rokhlin
 *
 */

import React from 'react';
import ClassNames from 'classnames';
import ClickAway from 'mixins/js/ClickAway';
import Paper from 'components/paper/Paper';
import FlatButton from 'components/buttons/flat-button/FlatButton';
import RaisedButton from 'components/buttons/raised-button/RaisedButton';
import IconButton from 'components/buttons/icon-button/IconButton';
import ListContainer from 'components/list/ListContainer';
import ListItem from 'components/list/ListItem';
import Menu from 'components/menu/Menu';
import Container from 'components/flexbox/Container';
import Block from 'components/flexbox/Block';

export default React.createClass({

	mixins: [ ClickAway ],

	manuallyBindClickAway: true,

	propTypes: {
		autoWidth: React.PropTypes.bool,
		onChange: React.PropTypes.func,
		menuItems: React.PropTypes.array.isRequired,
		customTrigger: React.PropTypes.any,
		triggerIcon: React.PropTypes.string,
		status: React.PropTypes.oneOf(['default', 'success','alert','primary','secondary','error']),
		menuAlign: React.PropTypes.oneOf(['left','right'])
	},

	getDefaultProps() {
		return {
			autoWidth: true,
			status: 'default',
			menuAlign: 'right'
		};
	},

	getInitialState() {
		return {
			open: false,
		}
	},

	componentClickAway() {
		this.setState({
			open: false
		});
	},

	componentDidMount() {
		this._setPosition();
	},

	componentDidUpdate(){
		if (this.state.open) {
			this._bindClickAway();
		} else {
			this._unbindClickAway();
		}
	},

	render() {
		let classes = ClassNames('lui-nav-menu', this.props.className, {
			'lui-open': this.state.open,
			'lui-menu-align-right' : this.props.menuAlign === 'right',
		});
			

		let trigger;

		if (this.props.customTrigger){
			let customTrigger = React.cloneElement(this.props.customTrigger,{
				onClick: this._toggleDropDown,
				ref: 'trigger'
			});

			trigger = customTrigger;
		
		} else {
		
			trigger = (<IconButton ref="trigger" icon={this.props.triggerIcon} onClick={this._toggleDropDown}/>)
		
		}

		return (
			<div className={classes}>
				<div className="lui-nav-menu-trigger">
					{trigger}
				</div>
				<div className="lui-nav-menu-dropdown" ref="dropdown">
					<Menu
						ref="menuItems"
						autoWidth={true}
						header={this.props.menuHeader}
						menuItems={this.props.menuItems}
						hideable={true}
						visible={this.state.open}
						status={this.props.status}
						onItemClick={this._onMenuItemClick} />
				</div>
			</div>
		);
	},

	_setPosition(){
		let menuItems = React.findDOMNode(this.refs.menuItems),
			dropdown = React.findDOMNode(this.refs.dropdown);

		dropdown.style.width = menuItems.offsetWidth + 'px';

	},
	_toggleDropDown(e){
		this.setState({
			open: !this.state.open
		});

		this._onActive();
	},
	
	_onActive(){
		if (this.props.onActive){
			this.props.onActive();
		}

	},

	_setWidth() {
		var el = React.findDOMNode(this),
			menuItemsDom = React.findDOMNode(this.refs.menuItems);

		el.style.width = menuItemsDom.offsetWidth + 'px';

	},

	_setSelectedIndex(props) {
		let selectedIndex = props.selectedIndex;

		if (process.NODE_ENV !== 'production' && selectedIndex < 0) {
			console.warn('Cannot set selectedIndex to a negative index.', selectedIndex);
		}

		this.setState({
			selectedIndex: (selectedIndex > -1) ? selectedIndex : 0
		});
	},

	_onMenuItemClick(e, key, payload) {
		if (this.props.onChange && this.state.selectedIndex !== key) this.props.onChange(e, key, payload);
		this.setState({
			selectedIndex: key,
			open: false
		});
	}

});



/** WEBPACK FOOTER **
 ** ./src/components/navbar/NavMenu.js
 **/